const scrollTop = document.getElementById('scroll__top');

if (scrollTop) {
  const toggleScrollTop = function () {
    scrollTop.classList.toggle('active', window.scrollY > 300);
  };

  scrollTop.addEventListener('click', function () {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', toggleScrollTop, { passive: true });
  toggleScrollTop();
}
